import { ApiBlueprint, createFrontendModule } from '@backstage/frontend-plugin-api';
import { configApiRef, discoveryApiRef, oauthRequestApiRef } from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import { microsoftAzUserAuthApiRef } from './microsoftAzUserAuthApiRef';

const microsoftAzUserAuthApi = ApiBlueprint.make({
  name: 'microsoft-az-user',
  params: defineParams =>
    defineParams({
      api: microsoftAzUserAuthApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
        OAuth2.create({
          configApi,
          discoveryApi,
          oauthRequestApi,
          provider: {
            id: 'microsoft-az-user',
            title: 'Azure AZ User',
            icon: () => null,
          },
          environment: configApi.getOptionalString('auth.environment'),
        }),
    }),
});

export const microsoftAzUserAuthModule = createFrontendModule({
  pluginId: 'app',
  extensions: [microsoftAzUserAuthApi],
});
